import React from 'react';
export { IsQueryClientReadyProvider, useIsQueryClientReady };
const IsQueryClientReadyContext = React.createContext(false);
const IsQueryClientReadyProvider = IsQueryClientReadyContext.Provider;
const useIsQueryClientReady = () => React.useContext(IsQueryClientReadyContext);